export var StatusFilter;
(function (StatusFilter) {
    StatusFilter[StatusFilter["FUTURE_AND_PAST"] = 0] = "FUTURE_AND_PAST";
    StatusFilter[StatusFilter["FUTURE_ONLY"] = 1] = "FUTURE_ONLY";
    StatusFilter[StatusFilter["PAST_ONLY"] = 2] = "PAST_ONLY";
})(StatusFilter || (StatusFilter = {}));
